import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js' //追加
import store from './store/index.js'


//BootstrapVueを登録
//BootstrapおよびBootstrapVue cssファイルをインポート
import BootstrapVue from 'bootstrap-vue'//追加
import 'bootstrap/dist/css/bootstrap.css' //追加
import 'bootstrap/dist/js/bootstrap.min' //追加
import 'bootstrap-vue/dist/bootstrap-vue.css'//追加


Vue.config.productionTip = false

new Vue({
  store,
  router, //追加
  BootstrapVue,
  render: h => h(App),
}).$mount('#app')
